<container kind="midi">
    <page-intro-header back="/subjects" [isAdmin]="isAdmin"
        title="{{ 'SUBJECT_DETAILS.TITLE' | translate }} - {{subject?.firstName}} {{subject?.lastName}}, {{'SUBJECT_DETAILS.REG_BR' | translate }} {{subject?.registrationId === null? '/' : subject?.registrationId }}">
        <span matTooltip="{{'SNACKBAR.ARCHIVE_UNARCHIVE_IMPOSSIBLE' | translate }}"
            [matTooltipDisabled]="subject?.status?.id !== 3">
            <button [disabled]="subject?.status?.id === 3" mat-flat-button color="primary" [matMenuTriggerFor]="menu"
                class="dropdown-button" *ngIf="!isAdmin && !isAssociate">
                {{ 'GLOBAL.MANAGE' | translate }}
                <mat-icon>arrow_drop_down</mat-icon>
            </button>
        </span>
        <mat-menu #menu="matMenu" xPosition="before">
            <span>
                <button *ngIf="!isArchived" mat-menu-item (click)="openDialog('archive', subject)">
                    <mat-icon>archive</mat-icon> {{ 'SUBJECT_DETAILS.ARCHIVE' | translate }}
                </button>
            </span>
            <span>
                <button *ngIf="isArchived && !isArchivedInCsr" mat-menu-item (click)="openDialog('unarchive', subject)">
                    <mat-icon>unarchive</mat-icon> {{ 'SUBJECT_DETAILS.UNARCHIVE' | translate }}
                </button>
            </span>
            <span>
                <button mat-menu-item (click)="openAssessmentDialog()">
                    <mat-icon>description</mat-icon> {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.TITLE' | translate }}
                </button>
            </span>
            <span>
                <button mat-menu-item (click)="openIntakeAssessmentDialog()">
                    <mat-icon>description</mat-icon> {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.TITLE' | translate }}
                </button>
            </span>
            <span>
                <button mat-menu-item (click)="openIndividualServicePlanDialog()">
                    <mat-icon>description</mat-icon> {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.TITLE' | translate }}
                </button>
            </span>
            <span>
                <button mat-menu-item (click)="openFunctionalEfficiencyAssessmentScaleDialog()">
                    <mat-icon>description</mat-icon> {{ 'SERVICE_PROVIDERS.FUNCTIONAL_EFFICIENCY_ASSESSMENT_SCALE.TITLE' | translate }}
                </button>
            </span>
        </mat-menu>
    </page-intro-header>
    <div *ngIf="subject?.serviceProviderStatus!=='PASSIVE'">
        <h4 class="assigned_dossier__title" *ngIf="subject?.serviceProviderDossierOwner!==null && subject?.serviceProviderDossierOwner!==''">
            {{ 'SUBJECT_DETAILS.DOSSIER_OWNER' | translate }}
            {{subject.serviceProviderDossierOwner}}</h4>
    </div>
    <div *ngIf="subject?.serviceProviderStatus==='PASSIVE'">
        <status-label status="{{2}}">
            {{ 'SUBJECT_DETAILS.DOSSIER_ARCHIVED' | translate }}
        </status-label>
    </div> 

    <mat-tab-group (selectedTabChange)="selectTab($event)" animationDuration="0">
        <mat-tab label="{{ 'SUBJECT_DETAILS.TAB_ONE' | translate }}" class="tab-content">
            <service-provider-subject-record [subject]="subject"></service-provider-subject-record> 
        </mat-tab>
        <mat-tab label="{{ 'SUBJECT_DETAILS.TAB_TWO' | translate }}" class="tab-content">
            <app-service-provider-subject-personal-info [subject]="subject" [familyDossier]="familyDossier"
                [showDivider]="showDivider" (reloadSubject)="reloadSubject($event)"></app-service-provider-subject-personal-info>
        </mat-tab>
        <mat-tab label="{{ 'SUBJECT_DETAILS.TAB_THREE' | translate }}">
            <ng-template matTabContent>
              <app-service-provider-subject-history [subjectId]="subject?.id"></app-service-provider-subject-history>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</container>